<template>
    <div class="d-flex justify-center">
        <alert ref="alert" />
        <v-fab-transition>
            <v-btn 
                v-scroll="onScroll"
                v-show="!isShowFab" 
                fab dark fixed top right color="primary" 
                @click="toDown()">
                <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
        </v-fab-transition>
        <v-fab-transition>
            <v-btn 
                v-scroll="onScroll" 
                v-show="isShowFab" 
                fab dark fixed bottom right color="primary" 
                @click="toTop()">
                <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
        </v-fab-transition>
        <v-form ref="whistleblowingForm" style="width: 100%" v-model="isDisabledSubmit" lazy-validation>
            <p class="headline font-weight-black primary--text" align="center">{{ $t("whistleblowing.content.title") }}</p>
            <p class="subtitle-1 red--text">{{ $t("whistleblowing.content.remark.required") }}</p>
            <ol :style="{color: $vuetify.theme.themes[theme].primary}" class="container-border ol-style">
                <v-row no-gutters>
                    <v-col cols="12">
                        <div :style="{background: $vuetify.theme.themes[theme].primary}" class="subtitle-container">
                            <li>{{ $t("whistleblowing.content.items.first.title") }}</li>
                        </div>
                        <ol>
                            <li>{{ $t("whistleblowing.content.items.first.sub.first.title") }} (<span class="red--text">*</span>)</li>
                            <v-row class="indent-container">
                                <v-radio-group v-model="form.anonymous" @change="changeIsAnonymousRadioGroup" row>
                                    <v-radio :label="$t('whistleblowing.content.items.first.sub.first.radio-group.yes.title')" v-bind:value="true"></v-radio>
                                    <v-radio :label="$t('whistleblowing.content.items.first.sub.first.radio-group.no.title')" v-bind:value="false"></v-radio>
                                </v-radio-group>
                            </v-row>
                            <div style="height: 250px;">
                                <div v-if="form.anonymous">
                                    <v-row align="center" no-gutters>
                                        <v-col cols="1" class="d-flex justify-end pa-md-2">
                                            <span class="red--text">*</span>
                                        </v-col>
                                        <v-col cols="10">
                                            <v-text-field clearable v-model.trim="anonymousUser.lastName" key="anonymousLastName_" :rules="[rules.required, rules.maxLength(anonymousUser.lastName, 20)]" :label="$t('whistleblowing.content.items.first.sub.first.radio-group.yes.content.lastName')"></v-text-field>
                                        </v-col>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="1">
                                            <span class="red--text"></span>
                                        </v-col>
                                        <v-col cols="10">
                                            <v-text-field clearable v-model.trim="anonymousUser.firstName" key="anonymousFirstName_" :rules="[rules.maxLength(anonymousUser.firstName, 20)]" :label="$t('whistleblowing.content.items.first.sub.first.radio-group.yes.content.firstName')"></v-text-field>
                                        </v-col>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="1">
                                            <span class="red--text"></span>
                                        </v-col>
                                        <v-col cols="10">
                                            <v-text-field clearable v-model.trim="anonymousUser.complaintsLine" key="anonymousComplaintsLine_" :rules="[rules.invalidNumber]" :counter="10" :label="$t('whistleblowing.content.items.first.sub.first.radio-group.yes.content.phoneNumber')"></v-text-field>
                                        </v-col>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="1" class="d-flex justify-end pa-md-2">
                                            <span class="red--text">*</span>
                                        </v-col>
                                        <v-col cols="10">
                                            <v-text-field clearable prepend-icon="mdi-email" v-model.trim="anonymousUser.email" key="anonymousEmail_" :rules="[rules.required, rules.invalidEmail]" :label="$t('whistleblowing.content.items.first.sub.first.radio-group.yes.content.email')"></v-text-field>
                                        </v-col>
                                        <v-col cols="1"></v-col>
                                    </v-row>
                                </div>

                                <div v-else>
                                    <v-row align="center" no-gutters>
                                        <v-col cols="1" class="d-flex justify-end pa-md-2">
                                            <span class="red--text">*</span>
                                        </v-col>
                                        <v-col cols="10">
                                            <v-text-field clearable v-model.trim="form.whistleblower" key="whistleblower_" :rules="[rules.required, rules.maxLength(form.whistleblower, 20)]" :label="$t('whistleblowing.content.items.first.sub.first.radio-group.no.content.name')" required></v-text-field>
                                        </v-col>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="1" class="d-flex justify-end pa-md-2">
                                            <span class="red--text">*</span>
                                        </v-col>
                                        <v-col cols="10">
                                            <v-text-field clearable v-model.trim="form.complaintsLine" key="phone_" :rules="[rules.required, rules.invalidNumber]" :counter="10" :label="$t('whistleblowing.content.items.first.sub.first.radio-group.no.content.phoneNumber')" required></v-text-field>
                                        </v-col>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="1" class="d-flex justify-end pa-md-2">
                                            <span class="red--text">*</span>
                                        </v-col>
                                        <v-col cols="10">
                                            <v-text-field clearable prepend-icon="mdi-email" v-model.trim="form.email" key="email_" :rules="[rules.required, rules.invalidEmail]" :label="$t('whistleblowing.content.items.first.sub.first.radio-group.no.content.email')" required></v-text-field>
                                        </v-col>
                                        <v-col cols="1"></v-col>
                                    </v-row>
                                </div>
                            </div>
                            <v-row no-gutters align="center">
                                <v-col cols="12">
                                    <v-card elevation="2" class="subtitle-1 mb-3">
                                        {{ $t("whistleblowing.content.items.first.sub.first.remark") }}
                                    </v-card>
                                </v-col>
                            </v-row>      
                            <li>{{ $t("whistleblowing.content.items.first.sub.second.title") }} (<span class="red--text">*</span>)</li>
                            <div class="indent-container">
                                <v-row no-gutters align="center">
                                    <v-col cols="12" sm="6">
                                        <v-radio-group v-model="form.relation" @change="changeRelationRadioGroup">
                                            <v-radio :label="$t('whistleblowing.content.items.first.sub.second.radio-group.first')" value="1"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.first.sub.second.radio-group.second')" value="2"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.first.sub.second.radio-group.third')" value="3"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.first.sub.second.radio-group.fourth')" value="4"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.first.sub.second.radio-group.fifth')" value="5"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.first.sub.second.radio-group.sixth')" value="6"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col cols="12" sm="5">
                                        <div v-if="(form.relation === '6')">
                                            <v-text-field v-model.trim="form.relationDescription" :rules="[rules.required, rules.maxLength(form.relationDescription, 50)]" :label="$t('whistleblowing.content.items.first.sub.second.description')" required></v-text-field>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </ol>
                    </v-col>

                    <v-col cols="12"> 
                        <div :style="{background: $vuetify.theme.themes[theme].primary}" class="subtitle-container">
                            <li value="2">{{ $t("whistleblowing.content.items.second.title") }} (<span class="red--text">*</span>)</li>
                        </div>
                        <ol>
                            <li>{{ $t("whistleblowing.content.items.second.sub.first.title") }}：</li>
                            <div style="min-height: 152px;" class="indent-container">
                                <v-row no-gutters align="center">
                                    <v-col cols="12" sm="6">
                                        <v-radio-group v-model="form.category" @change="changeCategoryRadioGroup">
                                            <v-radio :label="$t('whistleblowing.content.items.second.sub.first.radio-group.first')" value="1"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.second.sub.first.radio-group.second')" value="2"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.second.sub.first.radio-group.third')" value="3"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.second.sub.first.radio-group.fourth')" value="4"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.second.sub.first.radio-group.fifth')" value="5"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.second.sub.first.radio-group.sixth')" value="6"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col cols="12" sm="5">
                                        <div v-if="form.category === '6'">
                                            <v-text-field v-model.trim="form.categoryDescription" :rules="[rules.required, rules.maxLength(form.categoryDescription, 50)]" :label="$t('whistleblowing.content.items.second.sub.first.description')" required></v-text-field>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                            <li>{{ $t("whistleblowing.content.items.second.sub.second.title") }}：</li>
                            <div class="indent-container">
                                <v-row no-gutters align="center">
                                    <v-col cols="12" sm="6">
                                        <v-radio-group v-model="form.discovery" @change="changeDiscoveryRadioGroup">
                                            <v-radio :label="$t('whistleblowing.content.items.second.sub.second.radio-group.first')" value="1"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.second.sub.second.radio-group.second')" value="2"></v-radio>
                                            <v-radio :label="$t('whistleblowing.content.items.second.sub.second.radio-group.third')" value="3"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col cols="12" sm="5">
                                        <div v-if="form.discovery === '3'">
                                            <v-text-field v-model.trim="form.discoveryDescription" :rules="[rules.required, rules.maxLength(form.discoveryDescription, 50)]" :label="$t('whistleblowing.content.items.second.sub.second.description')" required></v-text-field>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                            <li>
                                {{ $t("whistleblowing.content.items.second.sub.third.title") }}：
                                <v-btn fab dark color="primary" icon @click="addContainer()"><v-icon dark>mdi-plus-circle</v-icon></v-btn>
                                <v-btn fab dark color="primary" icon @click="deleteContainer()"><v-icon dark>mdi-minus-circle</v-icon></v-btn>
                            </li>
                            <div style="height: 255px; overflow-x: hidden; overflow-y: auto;" class="indent-container">
                                <div v-for="(impeachEmployee, counter) in impeachEmployeeList" v-bind:key="counter" style="margin-left: 24px;">
                                    <v-row align="center">
                                        <label for="duration">{{counter+1}}. </label>
                                        <v-col cols="12" sm="4">
                                            <v-text-field clearable v-model.trim="impeachEmployee.department" :rules="[rules.required]" :label="$t('whistleblowing.content.items.second.sub.third.department')" required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field clearable v-model.trim="impeachEmployee.position" :rules="[rules.required]" :label="$t('whistleblowing.content.items.second.sub.third.position')" required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-text-field clearable v-model.trim="impeachEmployee.name" :rules="[rules.required]" :label="$t('whistleblowing.content.items.second.sub.third.name')" required></v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>

                            <li>{{ $t("whistleblowing.content.items.second.sub.fourth.title") }}：</li>
                            <v-row class="indent-container">
                                <v-col cols="12" sm="1" style="margin-top: 14px;"  class="d-flex justify-center">{{ $t("whistleblowing.content.items.second.sub.fourth.rangeFrom") }}</v-col>
                                <v-col cols="12" sm="5">
                                    <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model.trim="form.occurStartDate" :rules="[rules.required]" :hint="$t('whistleblowing.content.items.second.sub.fourth.hint')" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="startDate" no-title @input="!startMenu"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="1" style="margin-top: 14px;"  class="d-flex justify-center">{{ $t("whistleblowing.content.items.second.sub.fourth.rangeTo") }}</v-col>
                                <v-col cols="12" sm="5">
                                    <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model.trim="form.occurEndDate" :rules="[rules.required]" :hint="$t('whistleblowing.content.items.second.sub.fourth.hint')" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="endDate" no-title @input="!endMenu"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12">
                                    <v-alert class="text-center" :value="alert.isShow" :type="alert.displayType" dense outlined elevation="2" transition="scale-transition">{{ alert.message }}</v-alert>
                                </v-col>
                            </v-row>
                            <li>{{ $t("whistleblowing.content.items.second.sub.fifth.title") }}：</li>
                            <v-row class="indent-container">
                                <v-col cols="11">
                                    <v-text-field prepend-icon="mdi-map-marker" v-model.trim="form.occurAddress" :rules="[rules.required]" :label="$t('whistleblowing.content.items.second.sub.fifth.hint')" required></v-text-field>
                                </v-col>
                            </v-row>

                            <li>{{ $t("whistleblowing.content.items.second.sub.sixth.title") }}：</li>
                            <v-row class="indent-container">
                                <v-col cols="11">
                                    <v-textarea clearable v-model.trim="form.whistleblowingContent" :rules="[rules.required]" :label="$t('whistleblowing.content.items.second.sub.sixth.hint')" required></v-textarea>
                                </v-col>
                            </v-row>

                            <li>
                                {{ $t("whistleblowing.content.items.second.sub.seventh.title") }}： <br />
                                <span style="margin-left: 18px;" class="red--text">※{{ $t("whistleblowing.content.items.second.sub.seventh.remark.first") }}</span> <br />
                                <span style="margin-left: 18px;" class="red--text">※{{ $t("whistleblowing.content.items.second.sub.seventh.remark.second") }}</span>
                            </li>
                            <v-row class="indent-container">
                                <v-col cols="11">
                                    <v-file-input
                                        v-model="attachFile"
                                        truncate-length="15"
                                        prepend-icon="mdi-file-pdf"
                                        :hint="$t('whistleblowing.content.validations.attachFileSizeHint')"
                                        persistent-hint
                                        @change="previewFiles"
                                        chips
                                        show-size
                                        accept=".pdf"
                                    ></v-file-input>
                                </v-col>
                            </v-row>
                        </ol>
                    </v-col>
                </v-row>
            </ol>

            <p class="red--text">
                 <v-row no-gutters>
                    <v-col cols="1"></v-col>
                    <v-col cols="12" sm="6">
                        {{ $t("whistleblowing.content.remark.remind") }}
                    </v-col>
                    <v-col cols="5" sm="2">
                        <v-text-field :placeholder="$t('whistleblowing.content.identifyText')" v-model.trim="identify.code" :clearable="false" prop="identify"></v-text-field>
                    </v-col>
                    <v-col cols="7" sm="3">
                        <div class="code" @click="refreshCode">
                            <v-row no-gutters>
                                <identify :identifyCode="identify.identifyCode"></identify>
                                <v-btn icon color="green" @click="refreshCode">
                                    <v-icon>mdi-cached</v-icon>
                                </v-btn>
                             </v-row>
                        </div>
                    </v-col>
                </v-row>
            </p>

            <p class="text-center">
                <v-row no-gutters>
                     <v-col cols="1"></v-col>
                    <v-col cols="10">
                        <v-btn class="button" color="primary" rounded block :disabled="!isDisabledSubmit" @click="submit()">
                            {{ $t("whistleblowing.content.buttonText") }}
                        </v-btn>
                    </v-col>
                    <v-col cols="1"></v-col>
                </v-row>
            </p>
        </v-form>
    </div>
</template>

<script>
    import Alert from "../components/Alert";
    import HttpStatus from 'http-status-codes';
    import Store from "@/store";
    import Identify from "@/components/Identify";

    export default {
        name: "whistleblowingContent",
        components: {
            Alert,
            Identify
        },
        data() {
            const defaultForm = Object.freeze({
                whistleblowingId: 0,
                anonymous: true,
                whistleblower: "",
                email: "",
                complaintsLine: "",
                relation: "1",
                relationDescription: "",
                category: "1",
                categoryDescription: "",
                whistleblowingContent: "",
                occurStartDate: this.formatDate(new Date().toISOString().substr(0, 10)),
                occurEndDate: this.formatDate(new Date().toISOString().substr(0, 10)),
                occurAddress: "",
                discovery: "1",
                discoveryDescription: "",
            });

            const defaultImpeachEmployee = Object.freeze({
                impeachEmployeeId: 0,
                whistleblowingId: 0,
                caseCode: "",
                department: "",
                position: "",
                name: "",
            });

            const defaultAnonymousUser = Object.freeze({
                lastName: "",
                firstName: "",
                complaintsLine: "",
                email: "",
            });

            const defaultIdentify = Object.freeze({
                code: '',
                // 隨機取得4位數
                randomCodes: '1234567890abcdefghijklmnopqrstuvwxyz',
                identifyCode: '',
            });

            const defaultAlert = Object.freeze({
                isShow: false,
                message: "",
                displayType: "success",
                timeout: 5000,
            });

            return {
                anonymousUser: Object.assign({}, defaultAnonymousUser),
                isDisabledSubmit: true,
                startMenu: false,
                endMenu: false,
                startDate: new Date().toISOString().substr(0, 10),
                endDate: new Date().toISOString().substr(0, 10),
                form: Object.assign({}, defaultForm),
                attachFile: [],
                impeachEmployeeList: [Object.assign({}, defaultImpeachEmployee)],
                rules: {
                    required: (value) => !(!value || value.trim().length <= 0) || this.$t("whistleblowing.content.rules.required"),
                    maxLength: (value, maxLength) => {
                        if (!value || value.trim().length < 0) {
                            return true;
                        }
                        return value.length <= maxLength || this.$t("whistleblowing.content.rules.overMaxLengthTip").replace("LENGTH", maxLength)
                    },
                    invalidNumber: (value) => {
                        if (!value || value.trim().length < 0) {
                            return true;
                        }
                        const pattern = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{2,3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
                        return pattern.test(value) || this.$t("whistleblowing.content.rules.invalidNumberTip");
                    },
                    invalidEmail: (value) => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || this.$t("whistleblowing.content.rules.invalidEmailTip");
                    },
                },
                defaultForm,
                identify: Object.assign({}, defaultIdentify),
                alert: Object.assign({}, defaultAlert),
                isShowFab: false,
            };
        },

        mounted()  {
            this.identify.identifyCode = '';
            this.makeCode(4);
        },

        computed: {
            theme(){
                return (this.$vuetify.theme.dark) ? 'dark' : 'light'
            }
        },

        watch: {
            startDate (currentSelectDate) {
                const currentSelectDateTime = new Date(currentSelectDate).getTime();
                const endDateTime = new Date(this.endDate).getTime();
                if (currentSelectDateTime > endDateTime) {
                    this.showAlert("warning", this.$t("whistleblowing.content.validations.invalidStartDate"));
                    return;
                }
                this.form.occurStartDate = this.formatDate(currentSelectDate);
            },
            endDate (currentSelectDate) {
                const startDateTime = new Date(this.startDate).getTime();
                const currentSelectDateTime = new Date(currentSelectDate).getTime();
                if (currentSelectDateTime < startDateTime) {
                    this.showAlert("warning", this.$t("whistleblowing.content.validations.invalidEndDate"));
                    return;
                }
                this.form.occurEndDate = this.formatDate(currentSelectDate);
            },
        },

        methods: {
            onScroll(event) {
                if (typeof window === 'undefined'){
                    return;
                }
                const top = (window.pageYOffset ||   event.target.scrollTop || 0);
                this.isShowFab = (top > 20);
            },
            toTop() {
                this.$vuetify.goTo(0);
            },
            toDown() {
                this.$vuetify.goTo(document.body.scrollHeight);
            },
            // 驗證碼處理
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min)
            },
            // 刷新驗證碼
            refreshCode() {
                this.identify.identifyCode = ''
                this.makeCode(4)
            },
            makeCode(length) {
                for (let index = 0; index < length; index++) {
                    this.identify.identifyCode += this.identify.randomCodes[this.randomNum(0, this.identify.randomCodes.length)]
                }
            },
            addContainer() {
                this.impeachEmployeeList.push(
                    Object.assign({}, this.defaultImpeachEmployee)
                )
            },
            deleteContainer() {
                if ( this.impeachEmployeeList.length <= 1) {
                    return;
                }
                this.impeachEmployeeList.pop();
            },
            formatDate (date) {
                if (!date) {
                    return null;
                }
                const [year, month, day] = date.split('-')
                return `${year}/${month}/${day}`
            },
            showAlert(displayType, message) {
                this.alert.isShow = true;
                this.alert.displayType = displayType;
                this.alert.message = message;
                setTimeout(() => {
                    this.alert.isShow = false;
                }, this.alert.timeout);
            },
            changeIsAnonymousRadioGroup(anonymous) {
                if (anonymous) {
                    this.resetAnonymousData();
                }
                this.form.whistleblower = '';
                this.form.complaintsLine = '';
                this.form.email = '';
            },
            changeRelationRadioGroup(selectedValue) {
                if (selectedValue !== "6") {
                    this.form.relationDescription = "";
                }
            },
            changeCategoryRadioGroup(selectedValue) {
                if (selectedValue !== "6") {
                    this.form.categoryDescription = "";
                }
            },
            changeDiscoveryRadioGroup(selectedValue) {
                if (selectedValue !== "3") {
                    this.form.discoveryDescription = "";
                }
            },
            resetAnonymousData() {
                this.anonymousUser = Object.assign({}, this.defaultAnonymousUser);
            },
            resetForm() {
                this.$refs.whistleblowingForm.resetValidation()
                this.form = Object.assign({}, this.defaultForm);
                this.impeachEmployeeList = [Object.assign({}, this.defaultImpeachEmployee)];
                this.resetAnonymousData();
                this.attachFile = [];
            },
            async submit() {
                this.isDisabledSubmit = this.$refs.whistleblowingForm.validate();
                if (!this.isDisabledSubmit) {
                    await this.$refs.alert.showAlert("error", this.$t("whistleblowing.content.validations.invalidForm"));
                    return;
                }
                if (this.identify.identifyCode != this.identify.code || this.identify.code.length <= 0) {
                    await this.$refs.alert.showAlert("error", this.$t("whistleblowing.content.validations.invalidIdentifyCode"));
                    return;
                }
                const self = this;
                const keyName =  "whistleblower";
                const keyEmail =  "email";
                const keyPhone =  "complaintsLine";
                Object.keys(this.form).forEach((key) => {
                    const notExistsNameContent = (key == keyName && this.form[keyName] === "");
                    if (notExistsNameContent) {
                        const lastName = self.anonymousUser.lastName != null ? String(self.anonymousUser.lastName).trim() : '';
                        const firstName = self.anonymousUser.firstName != null ? String(self.anonymousUser.firstName).trim() : '';
                        if (this.$i18n.changeLocale === 'en_US') {
                            this.form[keyName] = firstName ? `${firstName}-${lastName}` : lastName;
                        } else {
                            this.form[keyName] = firstName ? lastName + firstName : lastName;
                        }
                    }

                    const notExistsEmailContent = (key == keyEmail && this.form[keyEmail] === "");
                    if (notExistsEmailContent) {
                        this.form[keyEmail] = self.anonymousUser.email;
                    }

                    const notExistsPhoneContent = (key == keyPhone && this.form[keyPhone] === "");
                    if (notExistsPhoneContent) {
                        this.form[keyPhone] = self.anonymousUser.complaintsLine;
                    }
                });
                
                const filesToUpload = this.normalizeAttachFiles();
                const isSubmitted = await this.submitWhistleblowing(filesToUpload);
                if (isSubmitted) {
                    const isFinished = await this.$refs.alert.showAlert("success", this.$t("whistleblowing.content.validations.sendFinished"));
                    this.resetForm();
                    if (isFinished) {
                        Store.commit("goBack");
                    }
                    return;
                }

                this.$refs.alert.showAlert("error", this.$t("whistleblowing.content.validations.sendFailed"));
            },

            async previewFiles(event) {
                const allowExtensions = ["application/pdf"];
                const maxFileSizeBytes = 100 * 1024 * 1024; // 100MB
                let fileNameExtension = "";
                const file = event == null ? null : (Array.isArray(event) ? event[0] : event);
                if (!file) {
                    return;
                }

                if (file.size > maxFileSizeBytes) {
                    this.attachFile = [];
                    await this.$refs.alert.showAlert("error", this.$t("whistleblowing.content.validations.invalidFileSize"));
                    return;
                }

                const fileType = file.type;
                if (fileType !== "") {
                    fileNameExtension = fileType;
                }

                const fileName = file.name;
                if (fileType === "" && fileName !== "") {
                    //取副檔名的正規表示式
                    const regular = /(?:\.([^.]+))?$/;
                    fileNameExtension = regular.exec(fileName)[1];
                }

                const disallow = (!allowExtensions.includes(fileNameExtension));
                if (disallow) {
                    this.attachFile = []; // cleared
                    await this.$refs.alert.showAlert("error", this.$t("whistleblowing.content.validations.invalidFileFormat"));
                }
            },
            
            async submitWhistleblowing(filesToUpload) {
                const formData = new FormData();
                formData.append("data", JSON.stringify({
                    whistleblowing: this.form,
                    impeachEmployeeList: this.impeachEmployeeList
                }));

                let localeIndex = 3;
                if (this.$i18n.changeLocale === "en_US") {
                    localeIndex = 1;
                }
                if (this.$i18n.changeLocale === "zh_CH") {
                    localeIndex = 2;
                }
                formData.append("localeIndex", localeIndex);
                (filesToUpload || []).forEach(file => formData.append("files", file, file.name));

                try {
                    const result = await this.$Http.post("/whistleblowing/api/whistleblowings/submit", formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    });
                    const httpStatus = parseInt(result.status);
                    if (httpStatus === HttpStatus.CREATED) {
                        return true;
                    }
                    if (httpStatus === HttpStatus.INTERNAL_SERVER_ERROR) {
                        await this.$refs.alert.showAlert("error", this.$t("whistleblowing.content.validations.sendMailFailed"));
                    }
                } catch (error) {
                    console.error(`error message：${error}`);
                }
                return false;
            },

            // 將 v-file-input 的值統一成陣列（未設 multiple 時可能是單一 File）
            normalizeAttachFiles() {
                const raw = this.attachFile;
                if (!raw) return [];
                return Array.isArray(raw) ? raw : [raw];
            },
        }
    }
</script>

<style>
.container-border {
    border: 2px solid;
    border-radius: 30px;
    padding: 25px;
    margin: 20px;
}
.subtitle-container {
    padding: 6px; 
    color: white;
}

.indent-container {
    margin-left: 20px !important;
}

.ol-style {
    list-style-position: inside;
}
.v-text-field {
    padding: 0px !important;
    margin: 4px !important;
}

.v-navigation-drawer--fixed {
    z-index: 0 !important;
}
</style>>